import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import config from "../config";
import { fetchRelaPro } from "../../src/components/util";
import { setCurrentCategoryData, setRelatedProducts } from "../store/slice";
import { useSelector , useDispatch} from "react-redux";

const Footer = () => {
  const { services, products } = useSelector((state) => state.data);
   const navigate = useNavigate();
   const dispatch = useDispatch();

  const [productsData, setProductsData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [showAllProducts, setShowAllProducts] = useState(false);
  const visibleProducts = showAllProducts ? productsData : productsData.slice(0, 7);

  useEffect(() => {
    setProductsData(products.categories || []);
    setServiceData(services || []);
  }, [products, services]);

  const handleClick = (categoryData) => {
    const { categorySlug, subCat = [], products: directProducts = [] } = categoryData;
  
    let firstProduct = directProducts?.[0];
    let matchedSubCat;
    let subCatSlug = '';
  
    // Try to find first product in subcategory if not found directly
    if (!firstProduct && subCat.length > 0) {
      for (let sub of subCat) {
        if (sub.products?.length > 0) {
          matchedSubCat = sub;
          firstProduct = sub.products[0];
          subCatSlug = sub.subCategorySlug;
          break;
        }
      }
    }
  
    if (firstProduct) {
      dispatch(setRelatedProducts(fetchRelaPro([firstProduct], categorySlug, subCatSlug, '')));
      dispatch(setCurrentCategoryData({ cat: categorySlug, subCat: subCatSlug }));
  
      // ✅ Navigate to product page using proper slug structure
      const route = subCatSlug
        ? `/product-page/${categorySlug}/${subCatSlug}`
        : `/product-page/${categorySlug}`;
  
      navigate(route, {
        state: {
          product: firstProduct,
          category: categoryData,
          ...(matchedSubCat ? { subCategory: matchedSubCat } : {})
        },
      });
    } else {
      // fallback: no products found
      dispatch(setCurrentCategoryData({ cat: categorySlug, subCat: '' }));
  
      // ✅ Even if no product, navigate with correct slug
      navigate(`/product-page/${categorySlug}`, {
        state: { category: categoryData },
      });
    }
  };

  
  const handleAboutUsClick = (id) => {
    navigate(`/about-us-section#${id}`);
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        const yOffset = -120;
        const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <footer className="footer" id="contactus">
      <div className="footer-container">

               {/* About Us */}
               <div className="footer-products">
        <div className="footer-logo">
          <h2>ABOUT US</h2>
          <div className="footer-add">
          {[
                { name: "Who We Are", path: "/about-us-section#who-we-are-section", id: "who-we-are-section" },
                { name: "What We Do", path: "/about-us-section#what-we-do-section", id: "what-we-do-section" },
                { name: "Sourcing Methodology", path: "/about-us-section#sourcing-methodology", id: "sourcing-methodology" },
                { name: "Vision, Mission, Values", path: "/about-us-section#vision-mission-value-section", id: "vision-mission-value-section" },
              ].map((link) => (
                <p
                  className="footer-text2"
                  key={link.name}
                  onClick={() => handleAboutUsClick(link.id)}
                  style={{ cursor: "pointer" }}
                >
                  <span className="footer-link">{link.name}</span>
                </p>
              ))}
          </div>
        </div>
        </div>

        {/* Products Section */}
        <div className="footer-products footer-products-col">
          <div className="footer-logo">
            <h2>PRODUCTS</h2>
            <div className="footer-add">
              {productsData.length > 0 ? (
                <>
                  {visibleProducts.map((product) => (
                    <p
                      className="footer-text2 footer-link"
                      key={product._id || product.categorySlug}
                      onClick={() => handleClick(product)}
                      style={{ cursor: "pointer" }}
                    >
                      {product.category.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
                    </p>
                  ))}
                  {productsData.length > 7 && (
                    <p
                      className="footer-text2 footer-show-more"
                      onClick={() => setShowAllProducts((prev) => !prev)}
                    >
                      {showAllProducts ? "Show less" : "Show more"}
                    </p>
                  )}
                </>
              ) : (
                <p className="footer-text2">No products available</p>
              )}
            </div>
          </div>
        </div>

     {/* Services Section */}
<div className="footer-products">
  <div className="footer-logo">
    <h2>SERVICES</h2>
    <div className="footer-add">
      {serviceData.length > 0 ? (
        serviceData.slice(0, 7).map((service) => {
          const encodedTitle = encodeURIComponent(
            service.title.toLowerCase().replace(/\s+/g, "-")
          );
          return (
            <p
              className="footer-text2 footer-link"
              key={service._id || service.title}
              onClick={() =>
                navigate(`/service-description/${encodedTitle}`, {
                  state: { service },
                })
              }
              style={{ cursor: "pointer" }}
            >
              {service.title.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
            </p>
          );
        })
      ) : (
        <p className="footer-text2">No services available</p>
      )}
    </div>
  </div>
</div>
 
        {/* Quick Links Section */}
        <div className="footer-products">
        <div className="footer-logo">
            <h2>QUICK LINKS</h2>
            <div className="footer-add">
              {[
              { name: "Gallery", path: "/gallery" },
              { name: "Career", path: "/career" },
              { name: "Contact Us", path: "/contact-us" },
              ].map((link) => (
                <p
                  className="footer-text2"
                key={link.name} // ✅ Unique key
                onClick={() => navigate(link.path)}
                  style={{ cursor: "pointer" }}
                >
                  <span className="footer-link">{link.name}</span>
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
